var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiverPayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2496_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 14.9845C11.6819 14.9845 14.6666 11.9997 14.6666 8.31779C14.6666 4.63589 11.6819 1.65112 7.99998 1.65112C4.31808 1.65112 1.33331 4.63589 1.33331 8.31779C1.33331 11.9997 4.31808 14.9845 7.99998 14.9845Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.40869V12.2271",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77686 5.83032H7.11151C6.78162 5.83032 6.46525 5.96137 6.23199 6.19463C5.99872 6.4279 5.86768 6.74427 5.86768 7.07415C5.86768 7.40404 5.99872 7.72041 6.23199 7.95367C6.46525 8.18694 6.78162 8.31798 7.11151 8.31798H8.88841C9.21829 8.31798 9.53466 8.44903 9.76793 8.68229C10.0012 8.91555 10.1322 9.23193 10.1322 9.56181C10.1322 9.8917 10.0012 10.2081 9.76793 10.4413C9.53466 10.6746 9.21829 10.8056 8.88841 10.8056H5.86768",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_1157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.317871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiverPayoutIcon);
export default __webpack_public_path__ + "static/media/waiver_payout_icon.9e61075b6e9135c1de467423219287ee.svg";
export { ForwardRef as ReactComponent };